module.exports = __webpack_public_path__ + "img/Vorschule.1225b310.svg";